/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-message[_ngcontent-%COMP%]{color:#fff}\n/*# sourceMappingURL=message-copied.component.css.map*/"];
export { styles as styles };
